import { Routes } from '@angular/router';
import { hisRootRoutes } from 'hisng';

export const ROUTE_CONFIG: Routes = [
    {
        path: 'employment',
        loadChildren: () => import( './fs/res/employment/employment-core.module' ).then( m => m.EmploymentCoreModule ),
        data: {
            modules: ['HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'doctoral',
        loadChildren: () => import( './fs/res/doctoral/doctoral-core.module' ).then( m => m.DoctoralCoreModule ),
        data: {
            modules: ['HISINONEDOC', 'HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'finance',
        loadChildren: () => import( './fs/res/finance/finance-core.module' ).then( m => m.FinanceCoreModule ),
        data: {
            anonmodules: ['HISINONERES', 'HISINONEKDSF'],
            modules: ['HISINONEBIA', 'HISINONERES', 'HISINONEKDSF']
        },
    },
    {
        path: 'researchRelationship',
        loadChildren: () => import( './fs/res/research-relationship/research-relationship-core.module' ).then(
            m => m.ResearchRelationshipCoreModule ),
        data: {
            modules: ['HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'pub',
        loadChildren: () => import( './fs/res/publication/publication-core.module' ).then( m => m.PublicationCoreModule ),
        data: {
            modules: ['HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'patent',
        loadChildren: () => import( './fs/res/patent/patent-core.module' ).then( m => m.PatentCoreModule ),
        data: {
            modules: ['HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'researchActivity',
        loadChildren: () => import( './fs/res/research-activity/research-activity-core.module' ).then(
            m => m.ResearchActivityCoreModule
        ),
        data: {
            modules: ['HISINONERES']
        }
    },
    {
        path: 'researchInfrastructure',
        loadChildren: () => import( './fs/res/research-infrastructure/research-infrastructure-core.module' ).then(
            m => m.ResearchInfrastructureCoreModule
        ),
        data: {
            modules: ['HISINONERES', 'HISINONEKDSF']
        }
    },
    {
        path: 'prizeNomination',
        loadChildren: () => import( './fs/res/prize-nomination/prize-nomination-core.module' ).then(
            m => m.PrizeNominationCoreModule
        ),
        data: {
            modules: ['HISINONERES']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppRoutesModule = hisRootRoutes(ROUTE_CONFIG, {});
